// __webpack_require__.r(__webpack_exports__);
// /* harmony export */ __webpack_require__.d(__webpack_exports__, {
// /* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
// /* harmony export */ });


class Applicator {
    constructor(section, options) {
        this.section = section;
        this.bundleType = section.getAttribute('data-bundle-type');
        this._selected = this.bundleType == 'applicator' ? {
            applicator: null,
            capsuleAmounts: null,
            subscribe: null,
            planReady: false,
            planType: null,
            scents: [],
            ready: false
        } : {
            applicator: true,
            scents: [],
            subscribe: null,
            planType: null,
            planReady: false,
            ready: false
        };
        // Elements
        this.stages = section.querySelector('#stages');
        this.switchBg = [...section.querySelectorAll('.switch-bg'), this.section]
        this.applicators = section.querySelectorAll('[name="options[color]"]');
        this.capsuleAmounts = section.querySelectorAll('.capsule-amount');
        this.btnSelectPlan = section.querySelector('.select-plan');
        this.plans = section.querySelector('#plans');    
        this.bundleBtnStart = section.querySelector('#bundle-btn-start');
        this.bundleBtnPrice = section.querySelector('#bundle-btn-price');
        this.bundleStandardInputs = section.querySelectorAll('.bundle-standard-input');
        this.bundleStandardInput = section.querySelector('.bundle-standard-input[value="subscribe"]');
        this.bundleStage = section.querySelectorAll('.bundle-stage');
        this.bundleStageSelectors = section.querySelectorAll('.stage-selector');
        this.bundleScentsSection = section.querySelector('#section-bundle-scents');
        this.bundleSelectPlan = section.querySelector('#section-select-plan');
        this.bundleTabSelector = section.querySelectorAll('.bundle-tab-selector');
        this.bundleTabTarget = section.querySelectorAll('.bundle-tab-target');
        this.bundleQtyBtn = section.querySelectorAll('.bundle-qty-btn');
        this.bundleQtyInput = section.querySelectorAll('.bundle-qty-input');
        this.bundleSummarySection = section.querySelector('#section-order-summary');
        this.bundlePrice = section.querySelector('#bundle-price');
        this.bundleComparePrice = section.querySelector('#bundle-compare-price');
        this.bundleSummary = section.querySelector('#bundle-summary');
        this.bundleSummarySubscribe = section.querySelector('#bundle-summary-subscribe');
        this.bundleSubmit = section.querySelector('#bundle-submit');
        this.bundleTimelineTicks = section.querySelectorAll('.bundle-timeline-tick');
        this.bundleModalSelector = section.querySelectorAll('.modal-selector');
        this.cartVariantId = section.querySelector('#cart-variant-id');
        this.singleSubmit = section.querySelector('#single-submit');

        // Prices
        this.formatter = new Intl.NumberFormat(section.getAttribute('data-shop-locale'), {
            style: 'currency',
            currency: section.getAttribute('data-shop-currency'),
            minimumFractionDigits: 2
        });
        this.subscriptionPrice = section.getAttribute('data-subscription-price');
        this.subscriptionComparePrice = section.getAttribute('data-subscription-compare-price');
        this.oneTimePurchasePrice = section.getAttribute('data-one-time-purchase-price');

        // Translations
        this.translations = JSON.parse(section.getAttribute('data-translations'));

        // Products
        this.applicatorProduct = JSON.parse(section.getAttribute('data-applicator-product'));

        // Images
        this.summaryBgImage = this.section.getAttribute('data-summary-background');
        this.summaryProductImage = this.section.getAttribute('data-summary-product');
        this.rememberedBackgroundScentImage = null;
        this.bundleCarousel = this.section.querySelector('.bundle-carousel');
        this.bundleCarouselSummaryBefore = this.bundleCarousel.querySelector('.bundle-summary-before');
        this.bundleCarouselSummaryAfter = this.bundleCarousel.querySelector('.bundle-summary-after')

        // Options
        if(options) {
            Object.entries(options).map((option) => {
                this[option[0]] = option[1];
            });
        }
    }

    // Select your plan is already enabled
    // Select your plan button doesn't change to Pick your scents until a scent amount is selected

    init() {
        console.log('Applicator initialized');
        this.listeners();
        this.addApplicator();
        this.updateUI();
    }

    // Utils
    classList(elt) {
        if(!elt) {
            return
        }
        var list = elt.classList;
      
        return {
            toggle: function(c) { list.toggle(c); return this; },
            add:    function(c) { list.add   (c); return this; },
            remove: function(c) { list.remove(c); return this; }
        };
    }

    isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            // rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    isInOrAboveViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    listeners() {
        // Applicators
        if(this.bundleType == 'applicator' || this.bundleType == "single") {
            for (let i = 0; i < this.applicators.length; i++) {
                this.applicators[i].addEventListener('change', (e) => {
                    this.scrollToBtn();
                    this.addApplicator();
                });
            }
        } else {
            this._selected.applicator = true;
        }
        
        // Quantity
        this.bundleQtyBtn.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                const target = e.target.classList.contains('bundle-qty-btn') ? e.target : e.target.closest('.bundle-qty-btn');
                if(target.classList.contains('bundle-btn-minus')) {
                  const   qtyInput = target.nextElementSibling;
                  console.log(qtyInput,"qtyInput")
                    const productCarde = target.closest('.product-card-new');
                          productCarde.classList.remove('active');

                    target.nextElementSibling.value =    
                        target.nextElementSibling.getAttribute('name') == 'quantity' ? 
                        target.nextElementSibling.value > 1 ? parseInt(target.nextElementSibling.value) - 1 : 1 :
                        target.nextElementSibling.value > 0 ? parseInt(target.nextElementSibling.value) - 1 : 0;
                    var bgImage = null;
                } else {
                     const productCard = target.closest('.product-card-new');
                     console.log(productCard,"qtyInput00000000");
                    productCard.classList.add('active');

                    target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
                    var bgImage = target.previousElementSibling.getAttribute('data-background') ? target.previousElementSibling.getAttribute('data-background') : null;
                }

                this.updateScents(bgImage);
                this.updateTimeline(true);
                if (this.bundleBtnStart){
                    this.bundleBtnStart.classList.add('hidden');
                }
            
            });
        });


        // Capsule Amounts
        // this.capsuleAmounts.forEach((capsuleAmount) => {
        //     capsuleAmount.addEventListener('click', (e) => {
        //         const amount = e.currentTarget.getAttribute('data-capsules');
        //         this.addCapsuleAmounts(amount);
        //     });
        // });

       if(this.bundleType !== 'scents') {
           // this._selected.capsuleAmounts = this._selected.subscribe == 'subscribe' ? 1 : 2 // subscription
             this._selected.capsuleAmounts = this._selected.subscribe == 'subscribe' ? 1 : 1 // one time
        }


        // Standard Inputs
        this.bundleStandardInputs.forEach((input) => {
            if(input.checked) {
                this.updateStandard({currentTarget: input});
            }
            input.addEventListener('change', (e) => {
                const new_applicatorProduct = JSON.parse(document.querySelector('.js-applicator').getAttribute('data-one-time-pro-json'));   const selectedVariant = (this.applicatorProduct.variants.find(variant => variant.id == this.applicator) || new_applicatorProduct.variants.find(variant => variant.id == this.applicator)); console.log(selectedVariant);  this._selected.applicator = {
                    variant: selectedVariant
                };       
                this.updateStandard(e);
               
                const valueNew = e.target.value;
                const closestfind = e.target;
                const pricediv = closestfind.closest('.subscribe_optio_find');
                const one_time_price = document.querySelectorAll('.meta_price span[line-line-through_new]');
                const freeTaG = document.querySelectorAll('.meta_price .meta_free_text');
                const stage_4_price = document.querySelector('.stage_4_price');
                const bottomprice = document.querySelector('.bundle-price_mob');
                const bundleBtnStart = this.bundleBtnStart;
                if(bundleBtnStart){

                    bundleBtnStart.classList.add('hidden');
                }
                if (valueNew === 'subscribe') {
                    freeTaG.forEach(el => el.style.display = 'inline');
                    one_time_price.forEach(el => el.style.display = 'inline');
                    const pricedivSub = pricediv?.querySelector('.subscribe_price');
                    if(pricedivSub && stage_4_price){
                        stage_4_price.innerHTML = pricedivSub.outerHTML;
                    }
                  
                    if(bottomprice && pricedivSub){

                        bottomprice.innerHTML = pricedivSub.outerHTML;
                    }

                }

                if (valueNew === 'one_time') {
                    one_time_price.forEach(el => el.style.display = 'none');
                    freeTaG.forEach(el => el.style.display = 'none');
                    const pricedivfind = pricediv?.querySelector('.one_time_price');
                    if(pricedivfind){
                        if(stage_4_price){
                            stage_4_price.innerHTML = pricedivfind.textContent;
                        }
                         if(bottomprice){
                            bottomprice.innerHTML = pricedivfind.textContent;
                        }
                    }
                    
                }
                
            });
        });

        // Bundle Tab Selector
        this.bundleTabSelector.forEach((tab) => {
            tab.addEventListener('click', (e) => {
                this.updateTabTarget(e);
            });
        });

        // Summary
        if(this.bundleSummarySection) {
            this._selected.ready = this.isInViewport(this.bundleSummarySection, { passive: true })
        }
        this.stages.addEventListener('scroll', () => {
            if(this.bundleSummarySection) {
                const ready = this.isInViewport(this.bundleSummarySection, { passive: true });
                if(ready != this._selected.ready) {
                    this._selected.ready = ready;
                    this.updateBackgroundImage(null);
                }
            }
            if(this.plans) {
                const planReady = this.isInOrAboveViewport(this.plans, { passive: true });
                if(planReady != this._selected.planReady) {
                    this._selected.planReady = planReady;
                    this.updateBackgroundImage(null);
                }
            }
            this.updateBtn();
            this.updateTimeline();
            this.updateCarousel();
            this.updateStageSelectors();
        });
        this.updateStageSelectors();

        // Submit
        if(this.bundleSubmit) {
            this.bundleSubmit.addEventListener('click', (e) => {
                this.submitCart();
            });
        }

        if(this.bundleType != 'single') {
            this.updateStageHeights();
            document.addEventListener('resize', () => {
                this.updateStageHeights();
            });
        }

        // Modal
        this.bundleModalSelector.forEach((modal) => {
            modal.addEventListener('click', (e) => {
                const modalTarget = e.currentTarget.getAttribute('data-modal-target');
                const modalTargetElement = this.section.querySelector(modalTarget);
                clearTimeout(window[modalTarget]);
                if(modalTargetElement) {
                    this.classList(modalTargetElement).toggle('hidden');
                    window[modalTarget] = setTimeout(() => {
                        this.classList(modalTargetElement).add('hidden');
                    }, 4000);
                }
            });
        })
    }

    // Getters
    get applicator () {
        return this.bundleType == 'applicator' || this.bundleType == 'single' ? this.section.querySelector('[name="options[color]"]:checked').value : null;
    }
    
    get scentQty () {
        return this._selected.scents.reduce((acc, scent) => {
            return acc + scent.qty;
        }, 0);
    }

    // Setters
    addApplicator() {
     const new_applicatorProduct = JSON.parse(document.querySelector('.js-applicator').getAttribute('data-one-time-pro-json'));   
     const selectedVariant = (this.applicatorProduct.variants.find(variant => variant.id == this.applicator) || new_applicatorProduct.variants.find(variant => variant.id == this.applicator)); 
     const variantId = this.applicator;

        const select_badge = window.variant_metafields?.[variantId]?.badge ?? null;
        const tagadd = document.querySelector('.variant_tag');

        if (tagadd) {
            if (select_badge) {
                tagadd.innerHTML = select_badge;
                tagadd.style.display = 'block'; // or 'inline-block' as per your CSS
            } else {
                tagadd.innerHTML = '';
                tagadd.style.display = 'none';
            }
        }
        const selectedVarianadd = document.querySelector('.variant_title-add');
        if(selectedVarianadd){
            selectedVarianadd.innerHTML = selectedVariant.title;
        }

        this._selected.applicator = {
            variant: selectedVariant
        };
        if(this.cartVariantId) {
            this.cartVariantId.value = selectedVariant.id;
        }
   
        this.updateUI();
    }

    // Set Capsule Amounts
    addCapsuleAmounts(amount) {
        this._selected.capsuleAmounts = parseInt(amount);
        if(this._selected.capsuleAmounts < this.scentQty) {
            this._selected.scents = [];
            // Reset inputs if they're too high
            this.updateResetInputs();
        }

        this.updateUI();
    }

    // Set Standard Inputs
    updateStandard(e) {
        const input = e.currentTarget;
        const value = input.value;
        const name = input.getAttribute('name');

        if(name == 'subscribe' && this.bundleType !== 'scents') {
    console.log('hiiii');        this._selected.scents = []
            this.updateResetInputs()
        }

      console.log('hiiii2');   this._selected[name] = value;
       if(this.bundleType !== 'scents') {
           // this._selected.capsuleAmounts = this._selected.subscribe == 'subscribe' ? 1 : 2 // subscription
             this._selected.capsuleAmounts = this._selected.subscribe == 'subscribe' ? 1 : 1 // one time
        }


        this.updateUI();
    }

    updateBackgroundImage(bgImage) {
        this.rememberedBackgroundScentImage = !bgImage ? this.rememberedBackgroundScentImage : bgImage;
        if(this.bundleType == 'scents') {
            this.section.style.backgroundImage = this._selected.ready && this.summaryBgImage ? `url(${this.summaryBgImage})` : bgImage ? `url(${bgImage})` : this.rememberedBackgroundScentImage ? `url(${this.rememberedBackgroundScentImage})` : 'unset';
        } else {
            this.section.style.backgroundImage = !this._selected.planReady ? 'unset' : this._selected.ready && this.summaryBgImage ? `url(${this.summaryBgImage})` : bgImage ? `url(${bgImage})` : this.rememberedBackgroundScentImage ? `url(${this.rememberedBackgroundScentImage})` : 'unset';
        }
    }

    // Set Scents
    updateScents(bgImage) {
        this.updateBackgroundImage(bgImage);
        this._selected.scents = [];
        this.bundleQtyInput.forEach((input) => {
            const value = input.value;
            const name = input.getAttribute('name');
            const variant = JSON.parse(input.getAttribute('data-variant'));
            const productName = input.getAttribute('data-product-name');
            const sellingPlans = input.getAttribute('data-selling-plans');
            const selectedSellingPlan = JSON.parse(sellingPlans).plans.find(sellingPlan => sellingPlan.name == this._selected.planType);

            if(value > 0) {
                this._selected.scents.push({
                    name: name,
                    variant: variant,
                    productName: productName,
                    qty: parseInt(value),
                    sellingPlan: selectedSellingPlan
                });
            }
        });

        this.updateUI();
    }

    // Update UI
    updateBtn () {

        console.log("this._selected.planReady || this.bundleType !== 'applicator'",this._selected.planReady || this.bundleType !== 'applicator');
        console.log("this._selected.planReady",this._selected.planReady);

        if(this._selected.planReady || this.bundleType !== 'applicator') {
            this.classList(this.bundleBtnPrice).remove('hidden').add('flex');
            this.classList(this.bundleBtnStart).remove('flex').add('hidden');
        } else {
            this.classList(this.bundleBtnStart).remove('hidden').add('flex');
            this.classList(this.bundleBtnPrice).remove('flex').add('hidden');
        }
    }

    updateStageSelectors () {
        let found = false;
        this.bundleStageSelectors.forEach((selector) => {
            if(found) {
                selector.classList.add('hidden')
            } else {
                // If scents, the button will be hidden if the scentQty is equal to the capsuleAmounts or if the capsuleAmounts is multiplied of 3 (for scents type)
                // If scents only section and planReady, the button will be hidden if planReady or ready
                const selectorTrue =    
                selector.getAttribute('data-stage-option') == 'planReady' ?
                    this._selected[selector.getAttribute('data-stage-option')] || this._selected.ready :
                    selector.getAttribute('data-stage-option') == 'scents' ? 
                        this.bundleType == 'applicator' ? 
                            this.scentQty == this._selected.capsuleAmounts : 
                                (this.scentQty % 3 == 0 && this.scentQty > 0) : 
                                    this._selected[selector.getAttribute('data-stage-option')]
                if(!selectorTrue) {
                    if(selector.getAttribute('data-stage-option') == 'scents') {
                        selector.textContent = selector.getAttribute('data-button-text').replace('XX', this._selected.capsuleAmounts - this.scentQty);
                    }
                    selector.classList.remove('hidden')
                    found = true;
                } else {
                    selector.classList.add('hidden')
                }
            }
        });
    }

    updateResetInputs () {
        this.bundleQtyInput.forEach((input) => {
            input.value = 0;
        });
    }

    updateTabTarget (e) {
        // Tab Target
        const target = e.currentTarget.getAttribute('data-target');
        this.bundleTabTarget.forEach((tabTarget) => {
            if(tabTarget.id == target) {
                this.classList(tabTarget).remove('hidden').add('flex');
            } else {
                this.classList(tabTarget).remove('flex').add('hidden');
            }
        });

        // Tab Selector
        this.bundleTabSelector.forEach((tabSelector) => {
            if(tabSelector.getAttribute('data-target') == target) {
                this.classList(tabSelector).add('capsule-active');
            } else {
                this.classList(tabSelector).remove('capsule-active');
            }
        });
    }

    updateSummary() {
        if(this._selected.subscribe == 'subscribe') {
            this.bundleSummarySubscribe.classList.remove('hidden')
        } else {
            this.bundleSummarySubscribe.classList.add('hidden')
        }


        const summaryData = {
            'applicator': this?._selected?.applicator ? '1 x ' : '',
            'capsuleAmountsPlural': this._selected.capsuleAmounts > 1 ? 's' : '',
            'capsuleAmounts': this._selected.capsuleAmounts ? this._selected.capsuleAmounts + ' x ' : '',
            'plan': this?._selected?.subscribe ? this._selected.subscribe == 'subscribe' ? this.translations.subscribe : this.translations.one_time : '',
            'scents': this._selected.scents.map((scent) => {
                return `
                <div class="flex items-center mb-2">
                <div class="w-14 h-14 rounded-lg flex items-center justify-center overflow-hidden">
                    ${scent?.variant?.featured_image?.src ? `<img class="w-full h-full object-cover" src="${scent?.variant?.featured_image?.src}" alt="${scent.variant.name}">` : ''}
                </div>
                <h5 class="text-sm font-semibold ml-2">${scent.qty} x ${scent.productName}</h5>
                </div>`
            }).join('')
        }
        
        Object.entries(summaryData).forEach(([key, value]) => {
            if(this.bundleSummarySection.querySelector(`[data-summary-${key}]`)) {
                this.bundleSummarySection.querySelector(`[data-summary-${key}]`).innerHTML = value;
            }
        });

        this.bundleSummarySection.querySelectorAll('[data-summary-show]').forEach((e) => {
            const summaryCheck = JSON.parse(e.getAttribute('data-summary-show'))
            this._selected[summaryCheck.key] == summaryCheck.value ? e.classList.remove('hidden') : e.classList.add('hidden')
        })
    }

    updateStageHeights() {
        const stageHeight = this.stages.offsetHeight - (this.bundleType == 'applicator' ? 60 : 20);
        this.bundleStage.forEach((stage) => {
            stage.style.minHeight = stageHeight + 'px';
        });
    }

    scrollToBtn() {
        if(this.bundleBtnStart) {
            if(!this.isInViewport(this.bundleBtnStart)) {
                window.scroll({
                    top: window.pageYOffset + this.bundleBtnStart.getBoundingClientRect().top, 
                    behavior: 'smooth'
                  });
            }
        } else if(this.bundleType == 'single' && this.singleSubmit) {
            if(!this.isInViewport(this.singleSubmit)) {
                window.scroll({
                    top: window.pageYOffset + this.bundleBtnStart.getBoundingClientRect().top, 
                    behavior: 'smooth'
                  });
                
            }
        }
    }

    updateUI() {
        const safeClasses = ['bg-cover', 'bg-center', 'bg-no-repeat']
        if(this._selected.applicator && (this.bundleType == 'applicator' || this.bundleType == 'single')) {
            // Update background colour
            const classToAdd = 'bg-' + this._selected.applicator.variant.title.replace(' ', '-').toLowerCase();
            this.switchBg.forEach((e) => {
                e.className.split(' ').map((className) => {
                    if(className.includes('bg-') && className !== classToAdd && !safeClasses.includes(className)) {
                        e.classList.remove(className);
                    }
                });
                e.classList.add(classToAdd);
            })
    
        
            // Update slider
          // setTimeout(function() {const slideIndex = this.section.querySelector(`[data-slide-variant="${this._selected.applicator.variant.id}"]`).getAttribute('data-slide-index'); this.slider.slideTo(slideIndex, 500);}, 2000);
            // const slideIndex = this.section.querySelector(`[data-slide-variant="${this._selected.applicator.variant.id}"]`).getAttribute('data-slide-index');
            // this.slider.slideTo(slideIndex, 500);
                    const slideEl = this.section.querySelector(
                `[data-slide-variant="${this._selected.applicator.variant.id}"]`
            );

            if (slideEl && this.slider) {
                const slideIndex = parseInt(slideEl.getAttribute('data-slide-index'), 10);
                this.slider.slideTo(slideIndex, 500);
            }
        }   

        if(this.bundleType == 'single') {
            return
        }

        this.capsuleAmounts.forEach((capsuleAmount) => {
            if(capsuleAmount.getAttribute('data-capsules') == this._selected.capsuleAmounts) {
                capsuleAmount.classList.add('border-[#ABCAE9]');
                capsuleAmount.classList.remove('border-[#E0DAD8]');
            } else {
                capsuleAmount.classList.remove('border-[#ABCAE9]');
                capsuleAmount.classList.add('border-[#E0DAD8]');
            }
        });

        // Update sections
        if(this._selected.capsuleAmounts || this.bundleType !== 'applicator') {
            this.plans.classList.remove('opacity-40');
            this.plans.classList.remove('pointer-events-none');
            this.bundleScentsSection.classList.remove('opacity-40');
            this.bundleScentsSection.classList.remove('pointer-events-none');
        }

        if(this.scentQty == this._selected.capsuleAmounts || (this.bundleType !== 'applicator' && this.scentQty % 3 == 0 && this.scentQty > 0)) {
            this.bundleSummarySection.classList.remove('opacity-50');
        } else {
            this.bundleSummarySection.classList.add('opacity-50');
        }

        // Update button
        this.updateBtn();

        // Update stage selectors
        this.updateStageSelectors();
        
        this.updateTimeline();

        // Update Scents
        if(this.bundleType !== 'scents') {
            this.bundleQtyBtn.forEach((btn) => {
                if(btn.classList.contains('bundle-btn-plus')) {
                    if(this.scentQty == this._selected.capsuleAmounts) {
                        btn.setAttribute('disabled', true);
                        btn.classList.add('opacity-40');
                    } else {
                        btn.removeAttribute('disabled');
                        btn.classList.remove('opacity-40');
                    }
                }
            });
        }


        // Update Price
        if(this._selected.applicator) {
            let price = this._selected.scents.reduce((total, scent) => {
                if(this._selected.subscribe == 'subscribe') {
                    return total + ((scent.variant.price - (scent.variant.price * (scent.sellingPlan.price_adjustments[0].value / 100))) * scent.qty);
                }
                return total + ((scent.variant.price) * scent.qty);
            }, 0);
            let compareAtPrice = this._selected.scents.reduce((total, scent) => {
                return total + (scent.variant.price * scent.qty);
            }, 0);
            price = this.bundleType == 'applicator' ? price + this._selected.applicator.variant.price : price;
            compareAtPrice = this.bundleType == 'applicator' ? compareAtPrice + this._selected.applicator.variant.price : compareAtPrice;
            this.bundlePrice.textContent = this.formatter.format(price / 100);
            this.bundleComparePrice.textContent = compareAtPrice > price && this._selected.subscribe == 'subscribe' ? this.formatter.format(compareAtPrice / 100) : '';

            if (location.href.includes('refillable-antiperspirant-natural-deodorant')) {
                
                // Price override 
                if (this.bundleStandardInput.checked) {
                    price = this.subscriptionPrice;
                    compareAtPrice = this.subscriptionComparePrice
                    this.bundlePrice.textContent = this.formatter.format(price / 100);
                    this.bundleComparePrice.textContent = this.formatter.format(compareAtPrice / 100) 
            } else {
                price = this.oneTimePurchasePrice;
                this.bundlePrice.textContent = this.formatter.format(price / 100);
                this.bundleComparePrice.textContent = ''
            }
            }
        }

        // Update Summary
        this.updateSummary();

        // Update Carousel();
        this.updateCarousel();
    }

    updateCarousel() {
        // Update carousel
        if(this._selected.ready) {
            this.bundleCarouselSummaryBefore.classList.add('hidden');
            this.bundleCarouselSummaryAfter.classList.remove('hidden');
        } else {
            this.bundleCarouselSummaryBefore.classList.remove('hidden');
            this.bundleCarouselSummaryAfter.classList.add('hidden');
        }

        if(this._selected.capsuleAmounts && this._selected.planReady) {
            this.section.classList.add('bundle-capsule-' + this._selected.capsuleAmounts)
            this.section.classList.remove('bundle-capsule-' + (this._selected.capsuleAmounts == 1 ? 2 : 1))
        } else {
            this.section.classList.remove('bundle-capsule-1')
            this.section.classList.remove('bundle-capsule-2')
        }
    }

    updateTimeline(check_click) {
        // Update Timeline
       
        this.bundleTimelineTicks.forEach((tick) => {
            // tick.classList.add('hidden');
            check_click
            ? tick.classList.remove('hidden')
            : tick.classList.add('hidden');
        });
        
        this.bundleTimelineTicks.forEach((tick) => {
            const tickStage = tick.getAttribute('data-timeline-stage');
            console.log("check_click",check_click);

            check_click
  ? tick.classList.remove('hidden')
  : tick.classList.add('hidden');

            //   tick.classList.add('hidden');
            if(tickStage == 'scents') {
                // Check if scents are selected and if the qty is equal to the capsule amount, or if the qty is a multiple of 3 if the bundle type is not applicator
                if(this.bundleType == "scents" ? this.scentQty % 3 == 0 && this.scentQty > 0 : this.scentQty == this._selected.capsuleAmounts && this._selected.planReady) {
                    tick.classList.remove('hidden');
                    console.log(this._selected.capsuleAmounts,"this._selected.capsuleAmounts")
                }
            // Check if stage is planReady and if the selected plan is subscribe, or if the selected plan is ready
            } else if(tickStage == 'planReady') {
                if(this.bundleType == "scents" ? this.scentQty % 3 == 0 && this.scentQty > 0 && this._selected.planReady : this._selected.planReady) {
                    tick.classList.remove('hidden');
                }
            } else {
                if(this._selected[tickStage]) {
                    tick.classList.remove('hidden');
                }
            }
        });
    }

    // Submit Cart
    submitCart () {
        const type = this.bundleType == 'Applicator' ? 'applicator' : this.bundleType == 'single' ? 'Single' : 'Scents';
        // Random ID
        const id = Date.now()

        const data = {
            'items': [
                ...this._selected.scents.map((scent) => {
                    return {
                        'id': scent.variant.id,
                        'quantity': scent.qty,
                        'selling_plan': this._selected.subscribe == 'subscribe' ? scent?.sellingPlan?.id ?? null : null,
                        'properties': {
                            '_Bundle': type + ' Bundle ' + id
                        }
                    }
                })
            ]
        }
        if(this.bundleType == 'applicator') {
            data.items.push({
                'id': this._selected.applicator.variant.id,
                'quantity': 1,
                'properties': {
                    '_Bundle': type + ' Bundle ' + id
                }
            })
        }

        fetch(this.section.getAttribute('data-cart-route') + '.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if(data.status == 422) {
                alert(data.description);
                return
            }
            window.location.href = window.theme.routes.cart;
        });
    }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Applicator);

//# sourceURL=webpack://make-waves-lifestyle/./src/js/applicator.js?